
document.addEventListener('DOMContentLoaded', () => {
  var $root = $('[data-reward-page-nav]');
  if (!$root.length) return;

  var $shell = $root.find('.reward-page-nav__shell');
  var $links = $root.find('.reward-page-nav__link');
  var $items = $root.find('.reward-page-nav__item');
  var mobileMax = 749;
  var showThreshold = 80;
  var scrollLockAnchor = null;
  var pinnedAnchor = null;
  var pinnedUntil = 0;

  var isMobile = function () {
    return window.innerWidth <= mobileMax;
  };

  function getNavHeight() {
    return $shell.outerHeight() || 0;
  }

  function setNavHeightVar() {
    document.documentElement.style.setProperty('--reward-page-nav-height', getNavHeight() + 'px');
  }

  function getAnchorGap() {
    return isMobile() ? 8 : 12;
  }

  function isNavVisible() {
    return $shell.hasClass('is-visible');
  }

  function getScrollOffset() {
    if (!isNavVisible()) return getAnchorGap();
    return getNavHeight() + getAnchorGap();
  }

  function getDestTop($dest) {
    if (!$dest.length) return 0;
    var marginTop = parseFloat($dest.css('margin-top')) || 0;
    return $dest.offset().top - marginTop;
  }

  function getDestScrollTop($dest) {
    return getDestTop($dest) - getScrollOffset();
  }

  function getDestination(anchorClass) {
    if (!anchorClass) return $();
    var anchor = String(anchorClass);
    var byId = document.getElementById(anchor);
    if (byId) return $(byId);
    var $matches = $(document.getElementsByClassName(anchor));
    var $section = $matches.filter('.section').first();
    if ($section.length) return $section;
    return $matches.first();
  }

  function setHash(anchorClass) {
    if (!anchorClass) return;
    var hash = '#' + String(anchorClass);
    if (window.location.hash === hash) return;
    if (history.replaceState) {
      history.replaceState(null, '', hash);
    } else {
      window.location.hash = anchorClass;
    }
  }

  function clearScrollLock() {
    scrollLockAnchor = null;
  }

  function pinAnchor(anchor, durationMs) {
    pinnedAnchor = anchor;
    pinnedUntil = Date.now() + durationMs;
  }

  function clearPinnedAnchor() {
    pinnedAnchor = null;
    pinnedUntil = 0;
  }

  function isPinned() {
    return pinnedAnchor && Date.now() < pinnedUntil;
  }

  function scrollToAnchor(anchorClass, animate) {
    var $dest = getDestination(anchorClass);
    if (!$dest.length) {
      clearScrollLock();
      return false;
    }

    function onScrollComplete() {
      clearScrollLock();
      pinAnchor(anchorClass, 350);
      setActiveByAnchor(anchorClass, true);
    }

    if (animate) {
      $('html, body').stop(true).animate(
        { scrollTop: getDestScrollTop($dest) },
        400,
        onScrollComplete
      );
    } else {
      $('html, body').scrollTop(getDestScrollTop($dest));
      onScrollComplete();
    }

    return true;
  }

  function scrollToHashFromUrl(animate) {
    var hash = window.location.hash.replace(/^#/, '');
    if (!hash) return;
    scrollLockAnchor = hash;
    scrollToAnchor(hash, animate);
  }

  function scrollActiveTabIntoView($item) {
    if (!isMobile() || !$item.length) return;
    var scroller = $item.closest('.reward-page-nav__mobile-scroller')[0];
    if (!scroller) return;
    var itemEl = $item[0];
    var targetLeft = itemEl.offsetLeft - (scroller.clientWidth - itemEl.offsetWidth) / 2;
    scroller.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
  }

  function getNavAnchors() {
    var anchors = [];
    $links.each(function () {
      var anchor = $(this).data('anchor');
      if (anchor && anchors.indexOf(anchor) === -1) {
        anchors.push(anchor);
      }
    });
    return anchors;
  }

  function getItemsForAnchor(anchor) {
    return $items.filter(function () {
      return $(this).find('.reward-page-nav__link[data-anchor="' + anchor + '"]').length;
    });
  }

  function setActiveByAnchor(anchor, scrollTab) {
    if (!anchor) return;
    var $matching = getItemsForAnchor(anchor);
    if (!$matching.length) return;

    var isSame = $matching.filter('.is-active').length === $matching.length;
    $items.removeClass('is-active');
    $matching.addClass('is-active');

    if (scrollTab && !isSame && isMobile()) {
      var $mobileItem = $matching.filter(function () {
        return $(this).closest('.reward-page-nav__mobile').length;
      }).first();
      if ($mobileItem.length) {
        scrollActiveTabIntoView($mobileItem);
      }
    }
  }

  function updateNavVisibility() {
    var scrollTop = $(window).scrollTop();
    var shouldShow = scrollTop >= showThreshold;

    if (shouldShow) {
      $shell.addClass('is-visible');
      $root.addClass('is-visible');
    } else {
      $shell.removeClass('is-visible');
      $root.removeClass('is-visible');
    }
  }

  function highlightOnScroll() {
    if (scrollLockAnchor) {
      setActiveByAnchor(scrollLockAnchor, false);
      return;
    }

    if (isPinned()) {
      setActiveByAnchor(pinnedAnchor, false);
      return;
    }

    clearPinnedAnchor();

    var line = $(window).scrollTop() + getScrollOffset();
    var currentAnchor = null;

    getNavAnchors().forEach(function (anchor) {
      var $dest = getDestination(anchor);
      if ($dest.length && getDestTop($dest) <= line + 4) {
        currentAnchor = anchor;
      }
    });

    if (!currentAnchor) return;

    var activeAnchor = $items.filter('.is-active').first().find('.reward-page-nav__link').data('anchor');
    if (activeAnchor !== currentAnchor) {
      setActiveByAnchor(currentAnchor, true);
    }
  }

  $links.on('click', function (e) {
    e.preventDefault();
    var anchor = $(this).data('anchor');

    clearPinnedAnchor();
    scrollLockAnchor = anchor;
    setActiveByAnchor(anchor, true);
    setHash(anchor);
    scrollToAnchor(anchor, true);
  });

  setNavHeightVar();
  updateNavVisibility();

  if (window.location.hash) {
    $shell.addClass('is-visible');
    $root.addClass('is-visible');
    requestAnimationFrame(function () {
      setNavHeightVar();
      scrollToHashFromUrl(false);
    });
  } else {
    highlightOnScroll();
  }

  $(window).on('hashchange', function () {
    scrollToHashFromUrl(true);
  });

  $(window).on('scroll', function () {
    updateNavVisibility();
    highlightOnScroll();
  });

  $(window).on('resize', function () {
    setNavHeightVar();
    updateNavVisibility();
    highlightOnScroll();
  });
});
